import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MojoFileUploadModule } from 'mojo-file-upload';

import { UploadContainerComponent, UploadModalContainerComponent } from './containers';
import { CandidateUploadRoutingModule } from './upload-routing.module';

const containers = [UploadContainerComponent, UploadModalContainerComponent];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CandidateUploadRoutingModule,
    MojoFileUploadModule,
    MatButtonModule,
  ],
  declarations: [...containers],
  exports: [...containers],
})
export class CandidateAttachmentsUploadModule {}
